import React from 'react';
import './ContentCreation.css';

const ContentCreation = () => {
  return (
    <section id="content-creation" className="sec">
      <div className="sec-inner">
        <div className="sec-label">11 — Content Creation</div>
        <h2 className="sec-title">YouTube &<br /><em>Content</em></h2>

        <div className="content-creation-body reveal">
          <div className="cc-text-container">
            <div className="cc-glow-orb"></div>
            <div className="cc-text-card">
              <h3 className="cc-heading">Empowering Developers & Tech Enthusiasts</h3>
              <p className="cc-paragraph">
                I share my learnings, experiences, and technical insights on my YouTube channel. From deep dives into <span className="highlight">Full-Stack Web Development</span>, <span className="highlight">Machine Learning</span>, and <span className="highlight">AI Research</span>, to practical tutorials on React, Node.js, and Python—my channel is designed to help developers build real-world skills.
              </p>
              <p className="cc-paragraph">
                Whether you're a beginner starting your coding journey or a professional looking to scale applications and implement complex algorithms, there's valuable content waiting for you.
              </p>
              
              <div className="cc-action">
                <a
                  href="https://www.youtube.com/@Bijosilin"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="cc-btn-premium"
                >
                  <span className="cc-btn-icon">
                    <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                      <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.5 12 3.5 12 3.5s-7.505 0-9.377.55a3.016 3.016 0 0 0-2.122 2.136C0 8.07 0 12 0 12s0 3.93.501 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.55 9.377.55 9.377.55s7.505 0 9.377-.55a3.016 3.016 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                    </svg>
                  </span>
                  <span className="cc-btn-text">Visit @Bijosilin</span>
                </a>
                <span className="cc-subscriber-badge">Subscribe for Tech Insights 🚀</span>
              </div>
            </div>
          </div>

          <div className="cc-video-wrapper">
            <div className="cc-video-decor"></div>
            <div className="cc-video-card">
              <div className="video-responsive">
                <iframe
                  src="https://www.youtube.com/embed/pdKLhTC_Ao4"
                  loading="lazy"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                  title="Content Creation Video"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContentCreation;
